<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/configuration")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.configuration") }}
        b-breadcrumb-item
          router-link(to="/configuration/proxy")
            i.fa.fa-server
            span.ml-1 {{ $tc("ui.proxies", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="proxySearch" :placeholder="$t('message.search_by_id_host_port')")
                  div.col-sm-3.col-md-2.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="host") {{ $t("ui.proxy_host") }}
                      b-form-radio(value="port") {{ $t("ui.proxy_port") }}
              div.col-md-12
                b-button(v-b-modal.addProxy type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_proxy") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: 60%;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position(style="width: 18%;")
                      span {{ $t('ui.proxy_id') }}
                    th.sticky-position(style="width: 18%;")
                      span {{ $t("ui.proxy_host") }}
                    th.sticky-position(style="width: 15%;")
                      span {{ $t("ui.proxy_port") }}
                    th.sticky-position(style="width: 11%;")
                      span {{ $t("ui.remark") }}
                    th.text-center.sticky-position(style="width: 10%;")
                      span {{ $t("ui.action") }}
                    th.text-center.sticky-position(style="width: 10%;z-index: 10;")
                      span {{ $t("ui.disabled") }}
                    th.text-right.sticky-position(style="width: 18%;")
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredProxyList")
                    td
                      span {{ item.proxy_id }}
                    td
                      span {{ item.proxy_host }}
                    td
                      span {{ item.proxy_port }}
                    td
                      span {{ item.remark }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td.actions
                      div.d-flex.justify-content-center.align-items-center
                        label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                          input.switch-input(type="checkbox" v-model="item.proxy_disabled" @change="changedDisable(item, $event)")
                          span.switch-slider(:data-checked='on' :data-unchecked='off')
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addproxy(@clicked="addProxy" @failed="handleFailed")
      editproxy(ref="editproxy" :proxyID="editSelectedProxyID" :proxyHost="editSelectedProxyHost" :proxyPort="editSelectedProxyPort" :proxyRemark="editSelectedProxyRemark" @clicked="editProxy" @failed="handleFailed")
      deleteproxy(ref="deleteproxy" :proxyID="deleteSelectedProxyID" :proxyHost="deleteSelectedProxyHost" :proxyPort="deleteSelectedProxyPort" @clicked="deleteProxy" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addproxy from "@/components/proxy/addProxy.vue";
import editproxy from "@/components/proxy/editProxy.vue";
import deleteproxy from "@/components/proxy/deleteProxy.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    addproxy,
    editproxy,
    deleteproxy,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      proxyList: [],
      proxySearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedProxyID: "",
      editSelectedProxyHost: "",
      editSelectedProxyPort: "",
      editSelectedProxyRemark: "",
      deleteSelectedProxyID: "",
      deleteSelectedProxyHost: "",
      deleteSelectedProxyPort: ""
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredProxyList() {
      return this.proxyList.filter(item => {
        if (this.filterBy == "host") {
          return item.proxy_host.toLowerCase().indexOf(this.proxySearch.toLowerCase()) > -1;
        } else if (this.filterBy == "port") {
          return item.proxy_port.toLowerCase().indexOf(this.proxySearch.toLowerCase()) > -1;
        } else {
          return item.proxy_id.toString().indexOf(this.proxySearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    let url = config.proxyListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.proxy
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.proxyList = response.data.tbl_proxy_list;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    changedDisable: function(disabled, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.disabled"),
          text: this.$t("message.change_disable_confirm", { name: disabled.proxy_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.submit(disabled, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !disabled.proxy_disabled;
          }
        });
    },
    submit: function(disabled, status) {
      let url = config.editProxyDisabledUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.proxy,
        proxy_id: disabled.proxy_id,
        proxy_disabled: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                disabled.proxy_disabled = status;
                this.$helpers.showDialog(this.$t("ui.disabled"), this.$t("message.success"), "success");
              } else {
                disabled.proxy_disabled = !status;
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onEdit(e) {
      this.editSelectedProxyID = e.proxy_id;
      this.editSelectedProxyHost = e.proxy_host;
      this.editSelectedProxyPort = e.proxy_port;
      this.editSelectedProxyRemark = e.remark;
      this.$refs.editproxy.$refs.editProxy.show();
    },
    onDelete(e) {
      this.deleteSelectedProxyID = e.proxy_id;
      this.deleteSelectedProxyHost = e.proxy_host;
      this.deleteSelectedProxyPort = e.proxy_port;
      this.$refs.deleteproxy.$refs.deleteProxy.show();
    },
    addProxy: function(proxyID, proxyHost, proxyPort, proxyRemark) {
      let newProxy = {
        proxy_id: proxyID,
        proxy_host: proxyHost,
        proxy_port: proxyPort,
        remark: proxyRemark,
        created_on: new Date()
      };

      this.proxySearch = "";
      this.proxyList.unshift(newProxy);
      this.$helpers.showDialog(this.$t("ui.combine.add_proxy"), this.$t("message.success"), "success");
    },
    editProxy: function(proxyID, proxyHost, proxyPort, proxyRemark) {
      this.proxyList.filter(function(proxyInfo) {
        if (proxyInfo.proxy_id == proxyID) {
          proxyInfo.proxy_host = proxyHost;
          proxyInfo.proxy_port = proxyPort;
          proxyInfo.remark = proxyRemark;
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_proxy"), this.$t("message.success"), "success");
    },
    deleteProxy: function(proxyID) {
      let i = this.proxyList
        .map(proxyInfo => {
          return proxyInfo.proxy_id;
        })
        .indexOf(proxyID);
      this.proxyList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_proxy"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
